export enum AnalyticsEvent {
  STORE_PAGE_HUB = "store.page.hub",
  STORE_ACTION = "store.action",
  STORE_ALTERNATIVE_PRODUCT_PRODUCT_METRIC_DISPLAY = "store.alternative_product.product_metric_display",
  STORE_ALTERNATIVE_PRODUCT_LIKE_DISLIKE = "store.alternative_product.like_dislike",
  STORE_ALTERNATIVE_PRODUCT_DISLIKE_FORM_SUBMITTED = "store.alternative_product.dislike_form_submitted",
  STORE_SIDEBAR_VIEW_NOTIFICATIONS = "store.sidebar.view_notifications",
  STORE_MEGA_MENU_DROPDOWN = "store.mega_menu.dropdown",
  STORE_MEGA_MENU_CLICK_TO_NAVIGATE = "store.mega_menu.click_to_navigate",
  STORE_EXPLORE_CLICK_TO_NAVIGATE = "store.explore.click_to_navigate",
  STORE_TREATMENT_PLAN_ADD_PRODUCT = "store.treatment_plan.add_product",
  STORE_TREATMENT_PLAN_RX_UPDATE = "store.treatment_plan.rx_update",
  STORE_TREATMENT_PLAN_RX_NAVIGATE_TO_PLAN_PAGE = "store.treatment_plan.navigate_to_plan_page",
  STORE_TREATMENT_PLAN_RX_DISCARD_EDIT = "store.treatment_plan.discard_edit",
  STORE_TREATMENT_PLAN_SELECT_REASON = "store.treatment_plan.select_reason",
  STORE_TREATMENT_PLAN_NEW = "store.treatment_plan.new",
  STORE_TREATMENT_PLAN_EDIT_PLAN = "store.treatment_plan.edit_plan",
  STORE_TREATMENT_PLAN_DUPLICATE_UPDATE = "store.treatment_plan.duplicate_update",
  STORE_TREATMENT_PLAN_RECENT_PLANS_DRAWER = "store.treatment_plan.recent_plans_drawer",
  STORE_TREATMENT_PLAN_VIEW_RESOURCES = "store.treatment_plan.view_resources",
  STORE_TREATMENT_PLAN_VIEW_PROTOCOL = "store.treatment_plan.view_protocol",
  STORE_TREATMENT_PLAN_ATTACH_SNIPPET = "store.treatment_plan.attach_snippet",
  STORE_TREATMENT_PLAN_ATTACH_DOCUMENT = "store.treatment_plan.attach_document",
  STORE_TREATMENT_PLAN_ATTACH_LIFESTYLE_RECOMMENDATION = "store.treatment_plan.attach_lifestyle_recommendation",
  STORE_TREATMENT_PLAN_SELECT_PATIENT = "store.treatment_plan.select_patient",
  STORE_TREATMENT_PLAN_TREATMENT_PLAN_MESSAGE = "store.treatment_plan.treatment_plan_message",
  STORE_TREATMENT_PLAN_VIEW_PLAN = "store.treatment_plan.view_plan",
  STORE_TREATMENT_PLAN_LOAD_MESSAGE_CTA = "store.treatment_plan.load_message_cta",
  STORE_TREATMENT_PLAN_GENERATE_MESSAGE = "store.treatment_plan.generate_message",
  STORE_TREATMENT_PLAN_NAVIGATE_TO_GENERATE_MESSAGE = "store.treatment_plan.navigate_to_generate_message",
  STORE_TREATMENT_PLAN_NAVIGATE_TO_SAVED_MESSAGES = "store.treatment_plan.navigate_to_saved_messages",
  STORE_TREATMENT_PLAN_SAVE_TREATMENT_PLAN_MESSAGE = "store.treatment_plan.save_treatment_plan_message",
  STORE_TREATMENT_PLAN_PATIENT_ACCESS_DRAWER = "store.treatment_plan.patient_access_drawer",
  STORE_TREATMENT_PLAN_CHANGE_STAFF_ACCESS = "store.treatment_plan.change_staff_access",
  STORE_TREATMENT_PLAN_CHANGE_ACCESS = "store.treatment_plan.change_access",
  STORE_TREATMENT_PLAN_VIEW_DRAFT = "store.treatment_plan.view_draft_plan",
  STORE_TREATMENT_PLAN_SEND_REMINDER = "store.treatment_plan.send_reminder",
  STORE_TREATMENT_PLAN_SEARCH = "store.treatment_plan.search",
  STORE_TREATMENT_PLAN_SAVE_COMMS_NOTE = "store.treatment_plan.save_comms_note",
  STORE_TREATMENT_PLAN_START = "store.treatment_plan.start",
  STORE_PROTOCOL_ADD_PRODUCT = "store.protocol.add_product",
  STORE_PROTOCOL_RX_UPDATE = "store.protocol.rx_update",
  STORE_PROTOCOL_APPLY = "store.protocol.apply",
  STORE_PROTOCOL_NEW = "store.protocol.new",
  STORE_PROTOCOL_VIEW = "store.protocol.view",
  STORE_PROTOCOL_EDIT = "store.protocol.edit",
  STORE_SIGNUP_FINISH_LATER = "store.signup.finish_later",
  STORE_PROTOCOL_ACTIVATE = "store.protocol.activate", // future cleanup: used only by effectively dead code
  STORE_SIGNUP_RESUME_ACCOUNT_ONBOARDING = "store.signup.resume_account_onboarding",
  STORE_SIGNUP_TO_SIGNUP_METHOD = "store.signup.to_signup_method",
  EMERSON_SIGNUP_TO_SIGNUP_METHOD = "emerson.signup.to_signup_method",
  STORE_SIGNUP_IM_A_PATIENT = "store.signup.im_a_patient",
  STORE_PRODUCT_VIEW = "store.product.view",
  STORE_PRODUCT_VIEW_FS_PREFERRED_PAGE = "store.product.view_fs_preferred_page",
  STORE_PRODUCT_VIEW_FS_TESTED_PAGE = "store.product.view_fs_tested_page",
  EMERSON_PRODUCT_VIEW = "emerson.product.view",
  EMERSON_PRODUCT_VIEW_IMAGE = "emerson.product.view_image",
  EMERSON_UNAUTH_PRODUCT_VIEW = "emerson_unauth.product.view",
  EMERSON_UNAUTH_PRODUCT_VIEW_IMAGE = "emerson_unauth.product.view_image",
  STORE_PRODUCT_VIEW_ALTERNATIVE_PRODUCTS = "store.product.view_alternative_products",
  STORE_PRODUCT_REMOVE_ALL_COMPARISONS = "store.product.remove_all_comparisons",
  STORE_PRODUCT_SELECT_FIRST_COMPARE = "store.product.select_first_compare",
  STORE_PRODUCT_REMOVE_FROM_COMPARISON = "store.product.remove_from_comparison",
  STORE_PRODUCT_SELECT_FOR_COMPARISON = "store.product.select_for_comparison",
  STORE_PATIENT_NEW_PATIENT = "store.patient.new_patient",
  STORE_PATIENT_CREATE = "store.patient.create",
  STORE_PATIENT_INFORMATION_BUTTON = "store.patient.information_button",
  STORE_PATIENT_CREATION_START = "store.patient_creation.start",
  CREATE_PATIENT_START = "create.patient_start",
  PATIENT_SEARCH_APPLY = "patient.search.apply",
  PATIENT_ORDER_TRACK_PACKAGE = "patient.order.click_track_package",
  PATIENT_ORDER_ORDER_NUMBER = "patient.order.click_order_number",
  PATIENT_SEARCH_APPLY_FILTER = "patient.search.apply_filter",
  PATIENT_PLATFORM_PAY_SHIPPING_METHOD_SELECTED = "patient.platform_pay.shipping_method_selected",
  STORE_SEARCH_APPLY = "store.search.apply",
  STORE_SEARCH_APPLY_FILTER = "store.search.apply_filter",
  STORE_LABS_APPLY_SEARCH = "store.labs.apply_search",
  STORE_LABS_APPLY_SEARCH_FILTER = "store.labs.apply_search_filter",
  STORE_LABS_TYPEAHEAD_SELECT = "store.labs.typeahead_select",
  STORE_PATIENT_IMPORT_PATIENTS = "store.patient.import_patients",
  STORE_STAFF_IMPORT_STAFF = "store.staff.import_staff",
  STORE_LABS_VIEW_SENT_TEST_DETAILS = "store.labs.view_sent_test_details",
  STORE_LABS_VIEW_UPCOMING_JOURNEY_DETAILS = "store.labs.view_upcoming_journey_details",
  STORE_LABS_VIEW_RESULTS = "store.labs.view_results",
  STORE_LABS_VIEW_INTERPRETATION = "store.labs.view_interpretation",
  STORE_LABS_VIEW_CONSULTATION_BOOKING = "store.labs.view_consultation_booking",
  STORE_LABS_VIEW_DOWNLOAD_RESULTS_MODAL = "store.labs.view_download_results_modal",
  STORE_LABS_DOWNLOAD_INTERPRETATION_RESULTS = "store.labs.download_interpretation_results",
  STORE_LABS_DOWNLOAD_INTERPRETATION_AND_WELLNESS_PLAN = "store.labs.download_interpretation_and_wellness_plan",
  STORE_LABS_VIEW_TEST_DESCRIPTION = "store.labs.view_test_description",
  STORE_LABS_VIEW_CUSTOM_PANEL = "store.labs.view_custom_panel",
  STORE_LABS_LEARN_MORE = "store.labs.learn_more",
  STORE_LABS_JOIN_WAITLIST = "store.labs.join_waitlist",
  STORE_LABS_VIEW_WAITLIST_BANNER = "store.labs.view_waitlist_banner",
  STORE_LABS_VIEW_JOURNEY_CTA = "store.labs.view_journey_cta",

  STORE_LABS_CHECKOUT_USE_INVENTORY = "store.labs.checkout_use_inventory",
  STORE_LABS_JOURNEY_BIOMARKER_FLAG = "store.labs_journey.biomarker_flag",
  STORE_LABS_JOURNEY_BIOMARKER_COMMENT = "store.labs_journey.biomarker_comment",
  STORE_LABS_JOURNEY_CANCEL_RECURRING_LAB = "store.labs_journey.cancel_recurring_lab",
  STORE_LABS_JOURNEY_REMOVE_LABS_JOURNEY = "store.labs_journey.remove_labs_journey",
  STORE_LABS_JOURNEY_BUILD_LABS_JOURNEY = "store.labs_journey.build_labs_journey",
  STORE_LABS_JOURNEY_TEST_TYPE = "store.labs_journey.test_type",
  STORE_LABS_JOURNEY_TEST_FREQUENCY = "store.labs_journey.test_frequency",
  STORE_LABS_JOURNEY_SEND_REMINDER = "store.labs_journey.send_reminder",
  STORE_LABS_INTERPRETATION_SHARE_WITH_PATIENT = "store.labs_interpretation.share_with_patient",
  STORE_LABS_INTERPRETATION_SHARE_WITH_PATIENT_WITHOUT_REVIEW = "store.labs_interpretation.share_with_patient_without_review",
  STORE_LABS_ORDER_DASHBOARD_VIEW_DETAILS = "store.labs.order_dashboard_view_details",
  STORE_LABS_ORDER_DASHBOARD_TAB_SELECT = "store.labs.order_dashboard_tab_select",
  STORE_LABS_ORDER_DASHBOARD_APPLY_FILTER = "store.labs.order_dashboard_apply_filter",
  STORE_LABS_ORDER_DASHBOARD_PATIENT_SEARCH = "store.labs.order_dashboard_patient_search",
  STORE_STAFF_NEW = "store.staff.new",
  STORE_STOREFRONT_STAFF_NEW = "store.storefront_staff.new",
  STORE_STOREFRONT_STAFF_UPDATE = "store.storefront_staff.update",
  STORE_TYPEAHEAD_SELECT = "store.typeahead.select",
  PATIENT_TYPEAHEAD_SELECT = "patient.typeahead.select",
  EXPERIMENT_ONBOARDING_QUESTION_1 = "experiment.onboarding.prac_question",
  EXPERIMENT_ONBOARDING_QUESTION_2 = "experiment.onboarding.patient_question",
  EXPERIMENT_ONBOARDING_QUESTION_3 = "experiment.onboarding.labs_question",
  EXPERIMENT_ONBOARDING_QUESTION_4 = "experiment.onboarding.supplements_question",
  EXPERIMENT_ONBOARDING_QUESTION_5 = "experiment.onboarding.primary_intent_question",
  STORE_CHECKOUT_ADD_TO_CART = "store.checkout.add_to_cart",
  EMERSON_CHECKOUT_ADD_TO_CART = "emerson.checkout.add_to_cart",
  PATIENT_ACCOUNT_SET_PASSWORD = "patient.account.set_password",
  PATIENT_CONSENT_SMS_OPT_IN = "patient.consent.sms_opt_in",
  PATIENT_CHECKOUT_SMS_OPT_IN = "patient.checkout.sms_opt_in",
  PATIENT_AUTOSHIP_REMOVE_ITEM = "patient.autoship.cancel_autoship_item",
  PATIENT_AUTOSHIP_MODIFY_ORDER = "patient.autoship.modify_autoship_order",
  PATIENT_COLLECTION_VIEW = "patient.collection.view",
  PATIENT_PRODUCT_VIEW = "patient.product.view",
  PATIENT_PRODUCT_VIEW_SIMILAR_PRODUCTS = "patient.product.view_similar_products",
  PATIENT_PRODUCT_REQUEST_ACCESS = "patient.product.request_access",
  PATIENT_PRODUCT_REQUEST_ALTERNATIVE = "patient.product.request_alternative",
  PATIENT_PRODUCT_REQUEST_INSTOCK_NOTIFICATION = "patient.product.request_instock_notification",
  PATIENT_PRODUCT_SELECT_AUTOSHIP = "patient.product.select_autoship",
  PATIENT_PRODUCT_VIEW_PRODUCT_ACCORDION = "patient.product.view_product_accordion",
  PATIENT_CHECKOUT_ADD_TO_CART = "patient.checkout.add_to_cart",
  PATIENT_CHECKOUT_ADD_ALL_TO_CART = "patient.checkout.add_all_to_cart",
  PATIENT_CHECKOUT_REMOVE_FROM_CART = "patient.checkout.remove_from_cart",
  PATIENT_VIEW_CART = "patient.checkout.view_cart",
  PATIENT_EDIT_CART = "patient.checkout.edit_cart",
  PATIENT_CHECKOUT_START = "patient.checkout.start",
  PATIENT_CHECKOUT_BACK_TO_CART = "patient.checkout.back_to_cart",
  PATIENT_CHECKOUT_BASKET_FILLERS_VIEWED = "patient.checkout.basket_fillers_viewed",
  PATIENT_CHECKOUT_PAYMENT_VIEWED = "patient.checkout.payment_viewed",
  PATIENT_CHECKOUT_DELIVERY_VIEWED = "patient.checkout.delivery_viewed",
  PATIENT_CHECKOUT_CONTINUE_TO_SHIPPING_ADDRESS = "patient.checkout.continue_to_shipping_address",
  PATIENT_CHECKOUT_SHIPPING_VIEWED = "patient.checkout.shipping_viewed",
  PATIENT_CHECKOUT_EDIT_ADDRESS = "patient.checkout.edit_address",
  PATIENT_CHECKOUT_CONFIRM_ADDRESS = "patient.checkout.confirm_address",
  PATIENT_CHECKOUT_ADDRESS_VALIDATION = "patient.checkout.address_validation",
  PATIENT_BUY_AGAIN_NAVIGATE_TO_PAGE = "patient.buy_again.navigate_to_page",
  PATIENT_PLAN_VIEW_FULL_PLAN = "patient.plan.view_full_plan",
  PATIENT_SURVEY_LOAD = "patient.survey.load",
  PATIENT_SURVEY_EXIT = "patient.survey.exit",
  PATIENT_SURVEY_SCORE_VIEW = "patient.survey.score_view",
  PATIENT_TREATMENT_PLAN_ACCESS_ERROR_DISMISSED = "patient.treatment_plan.access_error_dismissed",
  PATIENT_TREATMENT_PLAN_ACCESS_ERROR_VIEWED = "patient.treatment_plan.access_error_viewed",
  PATIENT_TREATMENT_PLAN_SWITCH_PROFILE_CLICKED = "patient.treatment_plan.switch_profile_clicked",
  STORE_CHECKOUT_START = "store.checkout.start",
  STORE_CHECKOUT_VIEW_CART_DROPDOWN = "store.checkout.view_cart_dropdown",
  EMERSON_CHECKOUT_VIEW_CART_DROPDOWN = "emerson.checkout.view_cart_dropdown",
  STORE_CHECKOUT_TO_SHIPPING = "store.checkout.to_shipping",
  EMERSON_CHECKOUT_TO_SHIPPING = "emerson.checkout.to_shipping",
  STORE_CHECKOUT_TO_PAYMENT = "store.checkout.to_payment",
  EMERSON_CHECKOUT_START = "emerson.checkout.start",
  EMERSON_CHECKOUT_TO_PAYMENT = "emerson.checkout.to_payment",
  EMERSON_ORDERS_CANCEL_BACKORDER = "emerson.orders.cancel_backorder",
  EMERSON_SEARCH_APPLY = "emerson.search.apply",
  EMERSON_SEARCH_APPLY_FILTER = "emerson.search.apply_filter",
  EMERSON_SEARCH_CLOSE_FILTER = "emerson.search.close_filter",
  EMERSON_UNAUTH_SEARCH_APPLY = "emerson_unauth.search.apply",
  EMERSON_UNAUTH_SEARCH_APPLY_FILTER = "emerson_unauth.search.apply_filter",
  EMERSON_UNAUTH_SEARCH_CLOSE_FILTER = "emerson_unauth.search.close_filter",
  EMERSON_WHOLESALE_POLICIES_ACCEPT_BRAND_AGREEMENT = "emerson.wholesale_policies.accept_brand_agreement",
  EMERSON_WHOLESALE_POLICIES_VIEW_BRAND_AGREEMENT = "emerson.wholesale_policies.view_brand_agreement",
  EMERSON_ACCOUNT_SETTINGS_GENERATE_TAX_EXEMPT_LINK = "emerson.account_settings.generate_tax_exempt_link",
  EMERSON_ACCOUNT_SETTINGS_GO_TO_CERT_EXEMPT_PROVIDER = "emerson.account_settings.go_to_cert_exempt_provider",
  EMERSON_CART_BECOME_TAX_EXEMPT = "emerson.cart.become_tax_exempt",
  EMERSON_PRODUCT_VIEW_FS_TESTED_PAGE = "emerson.product.view_fs_tested_page",
  STORE_SIGNUP_ERROR = "store.signup.error",
  PAGE_VIEW = "page.view",
  STORE_PAGE_VIEW = "store.page.view",
  UNAUTH_PAGE_VIEW = "unauth.page.view",
  UNAUTH_PAGE_CHECK_FOR_INV = "unauth.page.check_for_inv",
  EMERSON_PAGE_VIEW = "emerson.page.view",
  EMERSON_UNAUTH_PAGE_VIEW = "emerson_unauth.page.view",
  STORE_PILL_PACKS_VIEW = "store.pill_pack.banner_click",
  STORE_DASHBOARD_CLICK = "store.dashboard.click",
  STORE_REFERRAL_NAVIGATE_TO_REFERRALS_PAGE = "store.referral.navigate_to_referrals_page",
  STORE_REFERRAL_SHARE_REFERRAL = "store.referral.share_referral",
  STORE_REFERRAL_REFER_PRACTITIONER = "store.referral.refer_practitioner",
  STORE_LABS_START_SETUP = "store.labs.start_setup",
  STORE_LABS_ACCEPTED_TERMS_AND_CONDITIONS = "store.labs.accepted_terms_and_conditions",
  STORE_LABS_LAUNCH = "store.labs.launch",
  STORE_LABS_SEND = "store.labs.send",
  STORE_LABS_VIEW_REQUISITION = "store.labs.view_requisition",
  STORE_LABS_SEND_REMINDER = "store.labs.send_reminder",
  STORE_LABS_VIEW_PLAN = "store.labs.view_plan",
  STORE_LABS_VIEW_PREPARATION_INSTRUCTIONS = "store.labs.view_preparation_instructions",
  STORE_LABS_VIEW_PATIENT_DETAILS = "store.labs.view_patient_details",
  STORE_LABS_CREATE_CUSTOM_PANEL = "store.labs.create_custom_panel",
  STORE_LABS_START_REGISTRATION = "store.labs.start_registration",
  STORE_LABS_REGISTRATION_LICENSE = "store.labs.registration_license",
  STORE_LABS_REASON_FOR_TESTING_NOTE_FIELD_FOCUSED = "store.labs.reason_for_testing.note_field_focused",
  STORE_LABS_REASON_FOR_TESTING_NOTE_SAVED = "store.labs.reason_for_testing.note_saved",
  STORE_LABS_REASON_FOR_TESTING_PILL_SELECTED = "store.labs.reason_for_testing.pill_selected",
  STORE_LABS_RX_UPDATE = "store.labs.rx_update",
  STORE_LABS_INTRODUCING_LABS_CTA = "store.labs.introducing_labs_cta",
  STORE_LABS_CLICK_LABS_MARKETING_VIDEO = "store.labs.click_labs_marketing_video",
  STORE_LABS_BOOK_A_CALL_CTA = "store.labs.book_a_call_cta",
  STORE_LABS_BAA_LOAD_ATTEMPTED = "store.labs.baa_load_attempted",
  STORE_LABS_BAA_LOAD_SUCCEEDED = "store.labs.baa_load_succeeded",
  STORE_LABS_BAA_LOAD_FAILED = "store.labs.baa_load_failed",
  STORE_LABS_BAA_SESSION_ENDED_UNEXPECTEDLY = "store.labs.baa_session_ended_unexpectedly",
  STORE_LABS_BAA_SESSION_CANCELED = "store.labs.baa_session_canceled",
  STORE_LABS_BAA_REDIRECTED = "store.labs.baa_redirected",
  STORE_PAYMENTS_CHANGE_STORE_MARGIN = "store.payments.change_store_margin",
  STORE_PAYMENTS_ADD_BANK_ACCOUNT = "store.payments.add_bank_account",
  STORE_PAYMENTS_NAVIGATE_TO_PAYOUTS_PAGE = "store.payments.navigate_to_payouts_page",
  STORE_PAYMENTS_NAVIGATE_TO_PAYMENTS_PAGE = "store.payments.navigate_to_payments_page",
  STORE_SHOWCASE_ON_MY_WEBSITE = "store.product.embedded_card",
  STORE_VERIFY_TAX_ENTER_MODAL = "store.verify_tax.enter_modal",
  STORE_VERIFY_TAX_ADDRESS_DETAILS = "store.verify_tax.address_details",
  STORE_VERIFY_TAX_TAX_DETAILS = "store.verify_tax.tax_details",
  STORE_VERIFY_TAX_INITIAL_MESSAGE = "store.verify_tax.initial_message",
  STORE_VERIFY_TAX_E_DELIVERY = "store.verify_tax.e_delivery",
  STORE_WHOLESALE_POLICIES_ACCEPT_BRAND_AGREEMENT = "store.wholesale_policies.accept_brand_agreement",
  STORE_ACCOUNT_SETTINGS_GENERATE_TAX_EXEMPT_LINK = "store.account_settings.generate_tax_exempt_link",
  STORE_ACCOUNT_SETTINGS_GO_TO_CERT_EXEMPT_PROVIDER = "store.account_settings.go_to_cert_exempt_provider",
  STORE_SETTINGS_QUALITY_PROGRAM_TOGGLE = "store.settings.quality_program_toggle",
  USER_ACCOUNT_SETTINGS_TWO_FA_CHANGE = "user.account_settings.two_fa_change",
  EMERSON_ACCOUNT_SETTINGS_TWO_FA_CHANGE = "emerson.account_settings.two_fa_change",
  STORE_CART_BECOME_TAX_EXEMPT = "store.cart.become_tax_exempt",
  PATIENT_PAGE_VIEW = "patient.page.view",
  PATIENT_PILL_PACKS_VIEW = "patient.pill_pack.banner_click",
  PATIENT_PILL_PACK_CART_PROMO_VIEWED = "patient.pill_pack.cart_promo_viewed",
  PATIENT_PILL_PACK_CART_PROMO_DISMISSED = "patient.pill_pack.cart_promo_dismissed",
  PATIENT_PILL_PACK_CART_PROMO_CTA_CLICKED = "patient.pill_pack.cart_promo_cta_clicked",
  PATIENT_PILL_PACK_CART_PROMO_NOTIFY_SIGNUP = "patient.pill_pack.cart_promo_notify_signup",
  STORE_MIGRATION_LEARN_MORE = "store.migration.learn_more",
  STORE_MIGRATION_START_MIGRATION = "store.migration.start_migration",
  PATIENT_SHARED_PROTOCOL_VIEW_PROTOCOL = "patient.shared_protocol.view_protocol",
  SIGNUP_CHECK_PATIENT_INVITE = "store.signup.check_patient_invite",
  SIGNUP_CREDENTIAL_SKIP = "signup.credential_skip",
  SIGNUP_CREDENTIAL_SUBMIT = "signup.credential_submit",
  STORE_MIGRATION_FORGOT_WELLEVATE_PASSWORD = "store.migration.forgot_wellevate_password",
  STORE_MIGRATION_TO_CATALOG_PERMISSION = "store.migration.to_catalog_permission_settings",
  STORE_MIGRATION_START_UPGRADE_FS_TWO = "store.migration.start_upgrade_fs_two",
  STORE_MIGRATION_UPGRADE_TO_FS_TWO = "store.migration.upgrade_to_fs_two",
  STORE_MIGRATION_HOME_DATA_LINK_CLICKED = "store.migration_home.data_link_clicked",
  STORE_MIGRATION_HOME_SUPPORT_LINK_CLICKED = "store.migration_home.support_link_clicked",
  STORE_MIGRATION_HOME_BANNER_DISMISSED = "store.migration_home.banner_dismissed",
  STORE_MIGRATION_HOME_VIDEO_PLAYED = "store.migration_home.video_played",
  STORE_MIGRATION_HOME_CTA_CLICKED = "store.migration_home.cta_clicked",
  STORE_MIGRATION_HOME_ONBOARDING_TASK_CLICKED = "store.migration_home.onboarding_task_clicked",
  STORE_MIGRATION_HOME_RESOURCE_LINK_CLICKED = "store.migration_home.resource_link_clicked",
  STORE_PAGE_PLATFORM_SELECT = "store.page.platform_select",
  STORE_MANAGE_PATIENTS_SELECT_PATIENTS = "store.manage_patients.select_patients",
  STORE_MANAGE_PATIENTS_FILTER_PATIENTS = "store.manage_patients.filter_patients",
  STORE_MANAGE_PATIENTS_PRACTITIONER_ASSIGNMENT = "store.manage_patients.practitioner_assignment",
  STORE_MANAGE_PATIENTS_UNASSIGNED_PATIENTS_WARNING_BANNER = "store.manage_patients.unassigned_patients_warning_banner",
  STORE_PAYMENTS_SET_UP_PAYOUTS = "store.payments.set_up_payouts",
  STORE_PAYMENTS_BECOME_PROFIT_ACCOUNT = "store.payments.become_profit_account",
  STORE_PAYMENTS_SUBMIT_PROFIT_VERIFICATION = "store.payments.submit_profit_verification",
  STORE_PAYMENTS_ACTION_ADDITIONAL_PROFIT_INFORMATION = "store.payments.action_additional_profit_information",
  STORE_PAYMENTS_CUSTOM_FEE_SET = "store.payments.custom_fee_set",
  STORE_PAYMENTS_AUTOSHIP_AND_SAVE_BANNER_CLICK = "store.payments.autoship_and_save_banner_click",
  OPTIMIZE_OPT_IN_VIEW_MODAL = "store.optimize_opt_in.view_modal",
  OPTIMIZE_OPT_IN_APPLY_RECOMMENDED_SETTINGS = "store.optimize_opt_in.apply_recommended_settings",
  OPTIMIZE_OPT_OUT_VIEW_MODAL = "store.optimize_opt_out.view_modal",
  OPTIMIZE_OPT_OUT_UPDATE_SETTINGS = "store.optimize_opt_out.update_settings",
  PATIENT_PAGE_PLATFORM_SELECT = "patient.page.platform_select",
  PATIENT_MIGRATION_MIGRATION_COMPLETED = "patient.migration.migration_completed",
  RUPA_MIGRATION_START = "rupa.migration_start",
  RUPA_MIGRATION_SIGN_IN_SIGN_UP = "rupa.migration_sign_in_sign_up",
  RUPA_MIGRATION_AUTHORIZE_START = "rupa.migration_authorize_start",
  RUPA_MIGRATION_MOVE_ACCOUNT_CONFIRM = "rupa.migration_move_account_confirm",
  RUPA_MIGRATION_MOVE_DATA_CONFIRM = "rupa.migration_move_data_confirm",
  RUPA_MIGRATION_MOVE_DATE_SCHEDULED = "rupa.migration_move_date_scheduled",
  RUPA_MIGRATION_MOVE_TEAM_MEMBERS_CONFIRM = "rupa.migration_move_team_members_confirm",
  RUPA_MIGRATION_MOVE_PATIENTS_CONFIRM = "rupa.migration_move_patients_confirm",
  RUPA_MIGRATION_CONFIRM_MOVE = "rupa.migration_confirm_move",
  RUPA_MIGRATION_ERROR = "rupa.migration_error",
  RUPA_MIGRATION_REVIEW_DETAILS_COMPLETE = "rupa.migration_review_details_complete",
  STORE_FAVORITES_ADD_TO_FAVORITES = "store.favorites.add_to_favorites",
  STORE_FAVORITES_VIEW_CATEGORY = "store.favorites.view_category",
  STORE_FAVORITES_EDIT_CATEGORY = "store.favorites.edit_category",
  STORE_FAVORITES_CREATE_CATEGORY = "store.favorites.create_category",
  STORE_FAVORITES_START_SETUP = "store.favorites.start_setup",
  STORE_FAVORITES_SUPPLEMENT_TYPE = "store.favorites.supplement_type",
  STORE_TREATMENT_PLAN_CLOSE_DRAWER = "store.treatment_plan.close_drawer",
  STORE_FS_ASSIST_VIEW_EVIDENCE = "store.fs_assist.view_evidence",
  STORE_FS_ASSIST_DRAWER_OPEN = "store.fs_assist.drawer_open",
  STORE_FS_ASSIST_DRAWER_CLOSE = "store.fs_assist.drawer_close",
  STORE_FS_ASSIST_SELECTED_PRODUCT_PATIENT_INTERACTION = "store.fs_assist.selected_product_patient_interaction",
  STORE_FS_ASSIST_INTERACTIONS_SEVERITY_FILTER = "store.fs_assist.interactions_severity_filter",
  STORE_FS_ASSIST_CURRENTLY_TAKING_PRODUCT_INTERACTION = "store.fs_assist.currently_taking_product_interaction",
  STORE_FS_ASSIST_CURRENTLY_TAKING_DEPLETION = "store.fs_assist.currently_taking_depletion",
  STORE_FS_ASSIST_INTERACTION_CHECKER_OPEN = "store.fs_assist.interaction_checker_open",
  STORE_FS_ASSIST_DEPLETION_CHECKER_OPEN = "store.fs_assist.depletion_checker_open",
  STORE_FS_ASSIST_SELECTED_PRODUCT_GENERAL_INTERACTION = "store.fs_assist.selected_product_general_interaction",
  STORE_FS_ASSIST_GENERAL_INGREDIENT_OR_MEDICATION_SEARCH = "store.fs_assist.general_ingredient_or_medication_search",
  STORE_FS_ASSIST_BIOMARKER_OR_CONDITION_SEARCH = "store.fs_assist.biomarker_or_condition_search",
  STORE_FS_ASSIST_COMMON_INGREDIENT_OR_MEDICATION = "store.fs_assist.common_ingredient_or_medication",
  STORE_FS_ASSIST_PLAN_IN_PROGRESS_CLICK = "store.fs_assist.plan_in_progress_click",
  STORE_FS_ASSIST_DETAILED_INTERACTIONS_SEARCH_BAR = "store.fs_assist.detailed_interactions_search_bar",
  STORE_FS_ASSIST_INTERACTION_DETAIL_CLICK = "store.fs_assist.interaction_detail_click",
  STORE_FS_ASSIST_DETAIL_CLICK = "store.fs_assist.detail_click",
  STORE_FS_ASSIST_SEARCH_INGREDIENT = "store.fs_assist.search_ingredient",
  STORE_FS_ASSIST_SEARCH_LABS = "store.fs_assist.search_labs",
  STORE_FS_ASSIST_SEARCH_PRODUCT_FROM_DEPLETION = "store.fs_assist.search_product_from_depletion",
  STORE_FS_ASSIST_BIOMARKER_REFERENCE_GUIDE = "store.fs_assist.biomarker_reference_guide",
  STORE_FS_ASSIST_EXPAND_BIOMARKER_RESULTS = "store.fs_assist.expand_biomarker_results",
  STORE_FS_ASSIST_VIEW_OPTIMAL_RANGES_CONDITIONS = "store.fs_assist.view_optimal_ranges_conditions",
  STORE_FS_ASSIST_POTENTIAL_CONDITIONS_OPEN = "store.fs_assist.potential_conditions_open",
  STORE_FS_ASSIST_BIOMARKER_RANGE_FILTER = "store.fs_assist.biomarker_range_filter",
  STORE_FS_ASSIST_SELECT_LABS = "store.fs_assist.select_labs",
  STORE_FS_ASSIST_NEW_CHAT_STARTED = "store.fs_assist.new_chat_started",
  STORE_FS_ASSIST_PATIENT_ADDED_TO_CONTEXT = "store.fs_assist.patient_added_to_context",
  STORE_FS_ASSIST_PATIENT_CHANGED = "store.fs_assist.patient_changed",
  STORE_FS_ASSIST_PANEL_RESIZED = "store.fs_assist.panel_resized",
  STORE_FS_ASSIST_PROMPT_SENT = "store.fs_assist.prompt_sent",
  STORE_FS_ASSIST_FULLSCREEN_CLICKED = "store.fs_assist.fullscreen_clicked",
  STORE_FS_ASSIST_ATTACHMENTS_ADDED = "store.fs_assist.attachments_added",
  STORE_FS_ASSIST_STARTER_PROMPT_CLICKED = "store.fs_assist.starter_prompt_clicked",
  STORE_FS_ASSIST_FEEDBACK_SUBMITTED = "store.fs_assist.feedback_submitted",
  STORE_FS_ASSIST_SUPPLEMENT_REC_GENERATED = "store.fs_assist.supplement_rec_generated",
  STORE_FS_ASSIST_LIFESTYLE_REC_GENERATED = "store.fs_assist.lifestyle_rec_generated",
  STORE_FS_ASSIST_RESPONSE_RECEIVED = "store.fs_assist.response_received",
  STORE_FS_ASSIST_ERROR_DISPLAYED = "store.fs_assist.error_displayed",
  PATIENT_MOBILE_VIEW_IOS_APP = "patient.mobile.view_ios_app",
  PATIENT_MOBILE_VIEW_ANDROID_APP = "patient.mobile.view_android_app",
  PATIENT_WEB_MOBILE_SMART_BANNER_CLICK_GET = "patient.web_mobile_smart_banner.click_get",
  STORE_SEARCH_CLOSE_FILTER = "store.search.close_filter",
  STORE_PLAN_OPTIMIZATION_VIEW_SUGGESTIONS = "store.plan_optimization.view_suggestions",
  STORE_PLAN_OPTIMIZATION_COMPARE_PRODUCTS = "store.plan_optimization.compare_products",
  STORE_PLAN_OPTIMIZATION_ACCEPT_SUGGESTION = "store.plan_optimization.accept_suggestion",
  STORE_PLAN_DRAWER_OPEN = "store.plan_drawer.open",
  STORE_PLAN_DRAWER_ADD_RECOMMENDATION = "store.plan_drawer.add_recommendation",
  STORE_PLAN_DRAWER_REMOVE_RECOMMENDATION = "store.plan_drawer.remove_recommendation",
  STORE_PLAN_DRAWER_VIEW_RECOMMENDATION = "store.plan_drawer.view_recommendation",
  STORE_PLAN_DRAFT_PROMPT_RESPONDED = "store.plan_draft_prompt.responded",
  STORE_TREATMENT_PLAN_APPLY_RESOURCE_FILTER = "store.treatment_plan.apply_resource_filter",
  STORE_TREATMENT_PLAN_OPEN_RESOURCE_DOCUMENT = "store.treatment_plan.open_resource_document",
  STORE_TREATMENT_PLAN_CHANGE_PLAN_TYPE = "store.treatment_plan.change_plan_type",
  STORE_TREATMENT_PLAN_VIEW_ACCESS = "store.treatment_plan.view_access",
  STORE_TREATMENT_PLAN_EDIT_DOCUMENT = "store.treatment_plan.edit_document",
  STORE_PAYMENTS_TO_SETUP_AUTOSHIP_DISCOUNT = "store.payments.to_setup_autoship_discount",
  STORE_PAYMENTS_RECOMMENDED_DISCOUNT_MODAL_OPEN = "store.payments.recommended_discount_modal_open",
  STORE_PAYMENTS_RECOMMENDED_DISCOUNT_APPLY = "store.payments.recommended_discount_apply",
  STORE_IOC_ADD_ALL_TO_CART = "store.in_office_checkout.add_all_to_cart",
  STORE_IOC_ADD_TO_CART = "store.in_office_checkout.add_to_cart",
  STORE_IOC_START = "store.in_office_checkout.start",
  STORE_IOC_CONFIRM_AGE = "store.in_office_checkout.confirm_age",
  STORE_HUB_CTA_CLICK = "store.hub.cta_click",
  STORE_IOC_VIEW_AGE_VERIFICATION_MODULE = "store.in_office_checkout.view_age_verification_module",
  UNAUTH_MIGRATION_CONTINUE_MIGRATION = "unauth.migration.continue_migration",
  WELLEVATE_MIGRATION_FORGOT_WELLEVATE_PASSWORD = "wellevate.migration.forgot_wellevate_password",
  WELLEVATE_MIGRATION_TO_ACCOUNT_CREATION = "wellevate.migration.to_account_creation",
  STORE_DAILY_PACKS_APPLY_TEMPLATE_FILTER = "store.daily_packs.apply_daily_pack_template_filter",
  STORE_DAILY_PACKS_VIEW_DAILY_PACK_TEMPLATE = "store.daily_packs.view_daily_pack_template",
  STORE_DAILY_PACKS_CUSTOMIZE_DAILY_PACK = "store.daily_packs.customize_daily_pack",
  STORE_DAILY_PACKS_SAVE_AS_TEMPLATE = "store.daily_packs.save_as_template",
  STORE_TREATMENT_PLAN_VIEW_TEMPLATES_TAB = "store.treatment_plan.view_templates_tab",
  STORE_TREATMENT_PLAN_COPY_PLAN_LINK = "store.treatment_plan.copy_plan_link",
  STORE_TREATMENT_PLAN_UPDATE_PLAN = "store.treatment_plan.update_plan",
  STORE_TREATMENT_PLAN_APPLY_TEMPLATE = "store.treatment_plan.apply_template",
  STORE_TREATMENT_PLAN_ADD_ITEM_TO_DYNAMIC_DAILY_PACK = "store.treatment_plan.add_item_to_dynamic_daily_pack",
  STORE_TREATMENT_PLAN_APPLY_DAILY_PACK_FILTER = "store.treatment_plan.apply_daily_pack_filter",
  STORE_TREATMENT_PLAN_DELETE_PLAN = "store.treatment_plan.delete_plan",
  STORE_TREATMENT_PLAN_DELETE_DRAFT = "store.treatment_plan.delete_draft",
  STORE_PLANS_CANCELLED_TAB_CLICKED = "store.plans.cancelled_tab_clicked",
  STORE_PLANS_DELETE_CLICKED = "store.plans.delete_clicked",
  STORE_PLANS_DRAFTS_TAB_CLICKED = "store.plans.drafts_tab_clicked",
  STORE_PLANS_EDIT_CLICKED = "store.plans.edit_clicked",
  STORE_TREATMENT_PLAN_REVIEW_PLAN_HOVER_STATE = "store.treatment_plan.review_plan_hover_state",
  STORE_TREATMENT_PLAN_PREVIEW = "store.treatment_plan.preview",
  STORE_BREADCRUMBS_NAVIGATE = "store.breadcrumbs.navigate",
  STORE_SIDEBAR_TOGGLE_CLICK = "store.sidebar.toggle_click",
  STORE_SIDEBAR_AVATAR_MENU = "store.sidebar.avatar_menu",
  STORE_PATIENT_CURRENTLY_TAKING_VIEW = "store.patient.currently_taking_view",
  STORE_PATIENT_EXPORT_CURRENT_SUPPLEMENTS = "store.patient.export_current_supplements",
  STORE_PATIENT_REQUEST_SUPPLEMENT_CAPTURE = "store.patient.request_supplement_capture",
  STORE_PRACTITIONER_DOCUMENT_ACTION = "store.practitioner.document_action",
  PATIENT_MY_SCRIPT_ADD_PRODUCT = "patient.my_script.add_product",
  PATIENT_SUPPLEMENT_CAPTURE_START_INTAKE = "patient.supplement_capture.start_intake",
  STORE_THEME_DARK_MODE_TOGGLE = "store.theme.dark_mode_toggle",
  STORE_THEME_AUTOMATIC_DARK_MODE = "store.theme.automatic_dark_mode",
  PATIENT_THEME_DARK_MODE_TOGGLE = "patient.theme.dark_mode_toggle",
  PATIENT_DISCOUNT_LEARNMORE = "patient.discount.learn_more",
  STORE_PATIENT_VIEW = "store.patient.view_patient",
  PATIENT_AUTOSHIP_START_EDIT_DELIVERY_METHOD = "patient.autoship.start_edit_delivery_method",
  PATIENT_AUTOSHIP_UPDATE_DELIVERY_METHOD = "patient.autoship.update_delivery_method",
  PATIENT_AUTOSHIP_BROWSE_WELLNESS_ESSENTIALS = "patient.autoship.browse_wellness_essentials",
  PATIENT_AUTOSHIP_SELECT_RECOMMENDATION_CATEGORY = "patient.autoship.select_recommendation_category",
  PATIENT_AUTOSHIP_BROWSE_CATEGORY = "patient.autoship.browse_category",
  STORE_WHOLESALE_POLICIES_VIEW_BRAND_AGREEMENT = "store.wholesale_policies.view_brand_agreement",
  EMERSON_SHOP_MENU_DROPDOWN = "emerson.shop_menu.dropdown",
  EMERSON_SHOP_MENU_CLICK_TO_NAVIGATE = "emerson.shop_menu.click_to_navigate",
  EMERSON_UNAUTH_SHOP_MENU_DROPDOWN = "emerson_unauth.shop_menu.dropdown",
  EMERSON_UNAUTH_SHOP_MENU_CLICK_TO_NAVIGATE = "emerson_unauth.shop_menu.click_to_navigate",
  PATIENT_MY_SCRIPT_VIEW_BULK_ADD = "patient.my_script.view_bulk_add",
  PATIENT_MY_SCRIPT_BULK_SAVE_PRODUCT = "patient.my_script.bulk_save_product",
  STORE_TREATMENT_PLAN_EDIT_ACCESS = "store.treatment_plan.access_edit",
  STORE_CHECKOUT_EDIT_ADDRESS = "store.checkout.edit_address",
  STORE_CHECKOUT_CONFIRM_ADDRESS = "store.checkout.confirm_address",
  STORE_CHECKOUT_ADDRESS_VALIDATION = "store.checkout.address_validation",
  EMERSON_CHECKOUT_EDIT_ADDRESS = "emerson.checkout.edit_address",
  EMERSON_CHECKOUT_CONFIRM_ADDRESS = "emerson.checkout.confirm_address",
  EMERSON_CHECKOUT_ADDRESS_VALIDATION = "emerson.checkout.address_validation",
  PATIENT_LABS_BOOK_APPOINTMENT = "patient.labs.book_appointment",
  PATIENT_LABS_SCHEDULE_PHLEBOTOMY = "patient.labs.schedule_phlebotomy",
  PATIENT_LABS_RESCHEDULE_PHLEBOTOMY = "patient.labs.reschedule_phlebotomy",
  PATIENT_LABS_CANCEL_PHLEBOTOMY = "patient.labs.cancel_phlebotomy",
  PATIENT_LABS_SCHEDULE_MOBILE_PHLEBOTOMY = "patient.labs.schedule_mobile_phlebotomy",
  PATIENT_LABS_CANCEL_MOBILE_PHLEBOTOMY = "patient.labs.cancel_mobile_phlebotomy",
  PATIENT_LABS_RESCHEDULE_MOBILE_PHLEBOTOMY = "patient.labs.reschedule_mobile_phlebotomy",
  PATIENT_CHECKOUT_REMOVE_LAB_TEST = "patient.checkout.remove_lab_test",
  PATIENT_LABS_EXPRESS_CHECKOUT_FIELD_COMPLETED = "patient.labs_express_checkout.field_completed",
  PATIENT_LABS_EXPRESS_CHECKOUT_COLLECTION_METHOD_SELECTED = "patient.labs_express_checkout.collection_method_selected",
  PATIENT_LABS_EXPRESS_CHECKOUT_PAYMENT_METHOD_SELECTED = "patient.labs_express_checkout.payment_method_selected",
  PATIENT_LABS_VIEW_REQUISITION = "patient.labs.view_requisition",
  PATIENT_LABS_VIEW_TEST_DESCRIPTION = "patient.labs.view_test_description",
  PATIENT_LABS_VIEW_SENT_TEST_DETAILS = "patient.labs.view_sent_test_details",
  PATIENT_LABS_ENTER_INFORMATION = "patient.labs.enter_information",
  PATIENT_LABS_UPLOAD_BUTTON_CLICK = "patient.labs.upload_button_click",
  PATIENT_LABS_UPLOAD_SUCCESS = "patient.labs.upload_success",
  PATIENT_LABS_JOURNEY_DOWNLOAD_TEST_RESULTS = "patient.labs_journey.download_test_results",
  PATIENT_LABS_JOURNEY_MANAGE_UPCOMING_TEST = "patient.labs_journey.manage_upcoming_test",
  PATIENT_CURRENT_SUPPLEMENTS_NAVIGATE = "patient.my_script.navigate_to_current_supplements",
  PATIENT_MEGA_MENU_DROPDOWN = "patient.mega_menu.dropdown",
  PATIENT_MEGA_MENU_CLICK_TO_NAVIGATE = "patient.mega_menu.click_to_navigate",
  PATIENT_CHECKOUT_VIEW_AGE_VERIFICATION_MODULE = "patient.checkout.view_age_verification_module",
  PATIENT_CHECKOUT_CONFIRM_AGE = "patient.checkout.confirm_age",
  PATIENT_ACCOUNT_UPDATE_PERSONAL_PROFILE = "patient.account.update_personal_profile",
  PATIENT_ACCOUNT_ADD_NEW_PAYMENT_METHOD = "patient.account.add_new_payment_method",
  PATIENT_ACCOUNT_ADD_NEW_ADDRESS = "patient.account.add_new_address",
  EMERSON_QUICK_ORDER_OPEN_QUICK_ORDER = "emerson.quick_order.open_quick_order",
  EMERSON_ACCOUNT_MENU_SWITCH_PLATFORM = "emerson.account_menu.switch_platform",
  EMERSON_ACCOUNT_MENU_VIEW_MENU = "emerson.account_menu.view_menu",
  STORE_ACCOUNT_MENU_SWITCH_PLATFORM = "store.account_menu.switch_platform",
  STORE_PRODUCT_SWAP_VIEW = "store.product_swap.view",
  PATIENT_PRODUCT_SWAP_VIEW_ORIGINAL_PRODUCT = "patient.product_swap.view_original_product",
  STORE_PRODUCT_SWAP_VIEW_ORIGINAL_PRODUCT = "store.product_swap.view_original_product",
  PATIENT_PRODUCT_SWAP_VIEW_SUBSTITUTE_PRODUCTS = "patient.product_swap.view_substitute_products",
  STORE_PRODUCT_SWAP_START_ACTIVE_SWAP = "store.product_swap.start_active_swap",
  STORE_PRODUCT_SWAP_PREVIEW = "store.product_swap.preview",
  STORE_PRODUCT_SWAP_SELECT_PRODUCT = "store.product_swap.select_product",
  STORE_PRODUCT_SWAP_EDIT_SUBSTITUTE_PRODUCTS = "store.product_swap.edit_substitute_products",
  STORE_PRODUCT_SWAP_APPLY_FILTER = "store.product_swap.apply_filter",
  STORE_PRODUCT_SWAP_UPDATE_PLAN = "store.product_swap.update_plan",
  STORE_PRODUCT_SWAP_UPDATE_DOSAGE_INSTRUCTIONS = "store.product_swap.update_dosage_instructions",
  STORE_ANALYTICS_DASHBOARD_VIEW_EDUCATION = "store.analytics_dashboard.view_education",
  PATIENT_PUBLIC_FAVORITES_CLICK = "patient.public_favorites.click",
  PATIENT_LABS_SHIPPING_ALERT_ADD_TO_CART = "patient.labs.shipping_alert_add_to_cart",
  PATIENT_LABS_RESULTS_DELAY_ALERT_ADD_TO_CART = "patient.labs.results_delay_alert_add_to_cart",
  STORE_LABS_SHIPPING_ALERT_ADD_TO_PLAN = "store.labs.shipping_alert_add_to_plan",
  STORE_LABS_SHIPPING_ALERT_BACK = "store.labs.shipping_alert_back",
  STORE_LABS_SHIPPING_ALERT_REVIEW_PLAN = "store.labs.shipping_alert_review_plan",
  STORE_LABS_SHIPPING_ALERT_REMOVE_PLAN = "store.labs.shipping_alert_remove_plan",
  STORE_LABS_SHIPPING_ALERT_SEND_PLAN = "store.labs.shipping_alert_send_plan",
  STORE_LABS_RESULTS_DELAY_ALERT_ADD_TO_PLAN = "store.labs.results_delay_alert_add_to_plan",
  STORE_LABS_RESULTS_DELAY_ALERT_BACK = "store.labs.results_delay_alert_back",
  STORE_LABS_RESULTS_DELAY_ALERT_REVIEW_PLAN = "store.labs.results_delay_alert_review_plan",
  STORE_LABS_RESULTS_DELAY_ALERT_REMOVE_PLAN = "store.labs.results_delay_alert_remove_plan",
  STORE_LABS_RESULTS_DELAY_ALERT_SEND_PLAN = "store.labs.results_delay_alert_send_plan",
  STORE_LABS_ADD_TEST_TO_PLAN = "store.labs.add_test_to_plan",
  STORE_LABS_ADD_PANEL_TO_PLAN = "store.labs.add_panel_to_plan",
  STORE_LABS_ADD_TEST_TO_FAVORITES = "store.labs.add_test_to_favorites",
  STORE_LABS_REMOVE_TEST_FROM_FAVORITES = "store.labs.remove_test_from_favorites",
  STORE_LABS_SEARCH_PERFORMED = "store.labs.search_performed",
  STORE_LABS_COMPARE_PANEL_VIEW = "store.labs.compare_panel",
  STORE_LABS_PANEL_DETAILS_VIEW = "store.labs.panel_details",
  STORE_LABS_SWITCH_PANEL = "store.labs.switch_panel",
  STORE_LABS_TEMPLATE_PDP_VIEW = "store.labs_template_pdp.view",
  STORE_LABS_TEMPLATE_PDP_COPY_TO_TEMPLATES = "store.labs_template_pdp.copy_to_templates",
  STORE_LABS_TEMPLATE_PDP_BUILD_PLAN = "store.labs_template_pdp.build_plan",
  STORE_LABS_TEMPLATE_PDP_TIME_SPENT = "store.labs_template_pdp.time_spent",
  STORE_LABS_TEMPLATE_PDP_SCROLL_DEPTH = "store.labs_template_pdp.scroll_depth",
  STORE_LABS_TEMPLATE_PDP_TEST_NAME_CLICK = "store.labs_template_pdp.test_name_click",
  STORE_LABS_TEMPLATES_CAROUSEL_VIEW = "store.labs_templates_carousel.view",
  STORE_LABS_TEMPLATES_CAROUSEL_CARD_VIEW = "store.labs_templates_carousel.card_view",
  STORE_LABS_TEMPLATES_CAROUSEL_COLLAPSE_TOGGLE = "store.labs_templates_carousel.collapse_toggle",
  STORE_LABS_TEMPLATES_CAROUSEL_VIEW_ALL = "store.labs_templates_carousel.view_all",
  STORE_LABS_TEMPLATES_CAROUSEL_NAV = "store.labs_templates_carousel.nav",
  STORE_LABS_TEMPLATES_CAROUSEL_ADD_TO_PLAN = "store.labs_templates_carousel.add_to_plan",
  STORE_ONBOARDING_VIDEO_PLAYER = "store.onboarding.video_player",
  PATIENT_PLAN_ONBOARDING_EXIT = "patient.plan_onboarding.exit",
  PATIENT_RECOMMENDATION_CARD_TOGGLE_SELECTION = "patient.recommendation_card.toggle_selection",
  PATIENT_RECOMMENDATION_MESSAGE_READ_MORE = "patient.recommendation_message.read_more",
  PATIENT_RECOMMENDATION_CARD_LEARN_MORE = "patient.recommendation_card.learn_more",
  PATIENT_LIFESTYLE_RECOMMENDATION_SEE_MORE = "patient.lifestyle_recommendation.see_more",
  PATIENT_PLAN_COST_CALCULATE = "patient.plan_cost.calculate",
  STORE_TREATMENT_PLAN_EDIT_LIFESTYLE_RECOMMENDATION = "store.treatment_plan.edit_lifestyle_recommendation",
  STORE_TREATMENT_PLAN_REMOVE_LIFESTYLE_RECOMMENDATION = "store.treatment_plan.remove_lifestyle_recommendation",
  STORE_TREATMENT_PLAN_SMART_BUTTON_ACTION = "store.treatment_plan.smart_button_action",
  OVERLAY_VIEW = "overlay.view",
  STORE_SPOTLIGHT_CLICK_TO_NAVIGATE = "store.spotlight.click_to_navigate",
  BUTTON_CLICK = "button.click",
  PATIENT_FORK_SELECTION_SUBMIT = "patient.fork_selection.submit",
  STORE_CATEGORY_PAGE_CLICK_TO_NAVIGATE = "store.category_page.click_to_navigate",
  PATIENT_CATEGORY_PAGE_CLICK_TO_NAVIGATE = "patient.category_page.click_to_navigate",
  SEARCH_START = "search.search_start",
  NOTIFICATION_SELECT = "notification.select",
  NOTIFICATION_DISMISS = "notification.dismiss",
  STORE_PRODUCT_VIEW_IMAGE = "store.product.view_image",
  PATIENT_PRODUCT_VIEW_IMAGE = "patient.product.view_image",
  STORE_CATEGORY_PAGE_LOAD = "store.category_page.load",
  PATIENT_CATEGORY_PAGE_LOAD = "patient.category_page.load",
  PATIENT_ELEMENT_VIEW = "patient.element.view",
  BACK_NAVIGATION_SELECT = "back.navigation.select",
  PATIENT_SETTINGS_TOGGLE_CURRENTLY_TAKING_SHARING = "patient.settings.toggle_currently_taking_sharing",
  PATIENT_SETTINGS_TOGGLE_LAB_UPLOADS_SHARING = "patient.settings.toggle_lab_uploads_sharing",
  PATIENT_TERMS_ACCEPTED = "patient.terms.accepted",
  PATIENT_TERMS_VIEWED = "patient.terms.viewed",
  PATIENT_SPOTLIGHT_CLICK_TO_NAVIGATE = "patient.spotlight.click_to_navigate",
  PATIENT_SPOTLIGHT_VIEW_OURA_AFFILIATE_LINK = "patient.spotlight.view_oura_affiliate_link",
  PATIENT_PRODUCT_VIEW_FS_TESTED_PAGE = "patient.product.view_fs_tested_page",
  PATIENT_PRODUCT_VIEW_TOP_PICK_PAGE = "patient.product.view_top_pick_page",
  PATIENT_CHECKOUT_ADD_PROMO_CODE = "patient.checkout.add_promo_code",
  STOREFRONTS_PATIENT_CHECKOUT_ADD_TO_CART = "storefronts_patient.checkout.add_to_cart",
  STOREFRONTS_PATIENT_VIEW_CART = "storefronts_patient.checkout.view_cart",
  STOREFRONTS_PATIENT_PRODUCT_VIEW_IMAGE = "storefronts_patient.product.view_image",
  STOREFRONTS_PATIENT_MEGA_MENU_DROPDOWN = "storefronts_patient.mega_menu.dropdown",
  STOREFRONTS_PATIENT_PUBLIC_FAVORITES_CLICK = "storefronts_patient.public_favorites.click",
  STOREFRONTS_PATIENT_SHARED_PROTOCOL_VIEW_PROTOCOL = "storefronts_patient.shared_protocol.view_protocol",
  STOREFRONTS_PATIENT_EDIT_CART = "storefronts_patient.checkout.edit_cart",
  STOREFRONTS_PATIENT_PAGE_VIEW = "storefronts_patient.page.view",
  STOREFRONTS_PATIENT_PRODUCT_VIEW_SIMILAR_PRODUCTS = "storefronts_patient.product.view_similar_products",
  STOREFRONTS_PATIENT_PRODUCT_VIEW_PRODUCT_ACCORDION = "storefronts_patient.product.view_product_accordion",
  STOREFRONTS_PATIENT_MEGA_MENU_CLICK_TO_NAVIGATE = "storefronts_patient.mega_menu.click_to_navigate",
  STOREFRONTS_PATIENT_SEARCH_APPLY = "storefronts_patient.search.apply",
  STOREFRONTS_PATIENT_SEARCH_APPLY_FILTER = "storefronts_patient.search.apply_filter",
  STORE_COLLECTIONS_CREATE_COLLECTION = "store.collections.create_collection",
  STORE_COLLECTIONS_EDIT_COLLECTION = "store.collections.edit_collection",
  STORE_COLLECTIONS_ADD_PRODUCT = "store.collections.add_product",
  STORE_COLLECTIONS_ACTIVATE_COLLECTION = "store.collections.publish_collection",
  PATIENT_MOBILE_INTERRUPT_CLICK_DOWNLOAD_FULLSCRIPT = "patient.mobile_interrupt.click_download_fullscript",
  PATIENT_MOBILE_INTERRUPT_CLICK_CONTINUE_BROWSER = "patient.mobile_interrupt.click_continue_browser",
  STORE_CONVERSION_DRAWER_CLICK_ADD_FIRST_ORDER_DISCOUNT = "store.conversion_drawer.click_add_first_order_discount",
  STORE_PLAN_PAGE_CLICK_HELP_IMPROVE_CONVERSION = "store.plan_page.click_help_improve_conversion",
  STORE_CONVERSION_DRAWER_CLICK_SEND_REMINDER = "store.conversion_drawer.click_send_reminder",
  STORE_CONVERSION_DRAWER_MODAL_CLICK_SEND_REMINDER = "store.conversion_drawer_modal.click_send_reminder",
  STORE_CONVERSION_DRAWER_CLICK_VIDEO = "store.conversion_drawer.click_video",
  PATIENT_LABS_UPLOAD_TIME = "patient.labs.upload_time",
  PATIENT_LABS_METADATA_EDIT = "patient.labs.metadata_edit",
  PHLEBOTOMY_MAP_SEARCHED = "phlebotomy_map.searched",
  PHLEBOTOMY_MAP_SEARCH_NO_RESULTS = "phlebotomy_map.search_no_results",
  PHLEBOTOMY_MAP_TYPE_FILTER_CHANGED = "phlebotomy_map.type_filter_changed",
  PHLEBOTOMY_MAP_PROVIDER_FILTER_APPLIED = "phlebotomy_map.provider_filter_applied",
  PHLEBOTOMY_MAP_LOCATION_SELECTED = "phlebotomy_map.location_selected",
  PHLEBOTOMY_MAP_MAP_PIN_CLICKED = "phlebotomy_map.map_pin_clicked",
  PHLEBOTOMY_MAP_MAP_MOVED = "phlebotomy_map.map_moved",
  PHLEBOTOMY_MAP_BUILD_PLAN_CLICKED = "phlebotomy_map.build_plan_clicked",
  PHLEBOTOMY_MAP_INFO_CLICKED = "phlebotomy_map.info_clicked",
  PATIENT_INVITE_LINK_SHARED = "patient.invite_link_shared",
  PATIENT_INVITE_LINK_CONSENT_SHOWN = "patient.invite_link_consent_shown",
  PATIENT_INVITE_LINK_CONSENT_ACKNOWLEDGED = "patient.invite_link_consent_acknowledged",

  // journey.* — V2 patient-facing journey events
  JOURNEY_HOMEBASE_MODULE_CLICK = "journey.homebase.module.click",
  JOURNEY_HOMEBASE_VIEW = "journey.homebase.view",
  JOURNEY_HOMESCREEN_BANNER_CLICK = "journey.homescreen.banner.click",
  JOURNEY_HOMESCREEN_BANNER_VIEW = "journey.homescreen.banner.view",
  JOURNEY_NAVBAR_CLICK = "journey.navbar.click",
  JOURNEY_INTERPRETATION_VIEW = "journey.interpretation.view",
  JOURNEY_EXPAND_SUMMARY_CLICK = "journey.expand_summary.click",
  JOURNEY_HEALTH_AREA_CLICK = "journey.health_area.click",
  JOURNEY_VIEW_WELLNESS_PLAN_CLICK = "journey.view_wellness_plan.click",
  JOURNEY_BIOMARKER_CLICK = "journey.biomarker.click",
  JOURNEY_WELLNESS_PLAN_VIEW = "journey.wellness_plan.view",
  JOURNEY_EXPAND_ACTION_PLAN_CLICK = "journey.expand_action_plan.click",
  JOURNEY_LAB_DETAILS_EXPAND_CLICK = "journey.lab_details.expand.click",
  JOURNEY_RETEST_INTERVAL_CLICK = "journey.retest_interval.click",
  JOURNEY_SUPPLEMENTS_VIEW = "journey.supplements.view",
  JOURNEY_VIEW_CART_CLICK = "journey.view_cart.click",
  JOURNEY_RESOURCE_CLICK = "journey.resource.click",
  JOURNEY_INTERPRETATION_HEALTH_AREA_VIEW = "journey.interpretation.health_area.view",
  JOURNEY_BIOMARKER_DETAIL_VIEW = "journey.biomarker_detail.view",
  JOURNEY_REFERRAL_CLICK = "journey.referral.click",
  JOURNEY_PLAN_SEND_CLICK = "journey.plan_send.click",
  JOURNEY_RETEST_PANEL_CLICK = "journey.retest_panel.click",
  JOURNEY_PREVIOUS_INTERPRETATION_CLICK = "journey.previous_interpretation.click",
  JOURNEY_RETEST_CARD_CLICK = "journey.retest_card.click",
  JOURNEY_RETEST_CONTINUE_CART_CLICK = "journey.retest_continue_cart.click",
  JOURNEY_ORDER_BOOK_APPT_CLICK = "journey.order_book_appt.click",
  JOURNEY_FOLLOWUP_BOOK_APPT_CLICK = "journey.followup_book_appt.click",
  JOURNEY_FOLLOWUP_LINK_CLICK = "journey.followup_link.click",
  JOURNEY_FOLLOWUP_TIMING_CLICK = "journey.followup_timing.click",
  JOURNEY_WAITLIST_CTA_CLICK = "journey.waitlist_cta.click",
  JOURNEY_WEBSITE_PLP_VIEW = "journey.website.plp.view",
  JOURNEY_WEBSITE_PANEL_CARD_CLICK = "journey.website.panel_card.click",
  JOURNEY_WEBSITE_PLP_SHOW_MORE = "journey.website.plp.show_more",
  JOURNEY_WEBSITE_PDP_VIEW = "journey.website.pdp.view",
  JOURNEY_CHECKOUT_START = "journey.checkout.start",
  JOURNEY_CHECKOUT_LOCATION_VIEW = "journey.checkout.location.view",
  JOURNEY_CHECKOUT_LOCATION_SUBMIT = "journey.checkout.location.submit",
  JOURNEY_CHECKOUT_PATIENT_VIEW = "journey.checkout.patient.view",
  JOURNEY_CHECKOUT_PATIENT_SUBMIT = "journey.checkout.patient.submit",
  JOURNEY_CHECKOUT_SIGNIN_VIEW = "journey.checkout.signin.view",
  JOURNEY_CHECKOUT_SIGNIN_SUBMIT = "journey.checkout.signin.submit",
  JOURNEY_CHECKOUT_PAYMENT_VIEW = "journey.checkout.payment.view",
  JOURNEY_CHECKOUT_PAYMENT_SUBMIT = "journey.checkout.payment.submit",
  JOURNEY_CHECKOUT_BACK = "journey.checkout.back",
  JOURNEY_CHECKOUT_SAMPLE_COLLECTION_VIEW = "journey.checkout.sample_collection.view",
  JOURNEY_CHECKOUT_SAMPLE_COLLECTION_SELECT = "journey.checkout.sample_collection.select",
  JOURNEY_LABS_SCHEDULE_MOBILE_PHLEBOTOMY_VIEW = "journey.labs.schedule_mobile_phlebotomy.view",
  JOURNEY_LABS_BOOK_MOBILE_PHLEBOTOMY_CLICK = "journey.labs.book_mobile_phlebotomy.click",
  JOURNEY_LABS_CANCEL_MOBILE_PHLEBOTOMY_CLICK = "journey.labs.cancel_mobile_phlebotomy.click",
  JOURNEY_LABS_RESCHEDULE_MOBILE_PHLEBOTOMY_CLICK = "journey.labs.reschedule_mobile_phlebotomy.click",
  JOURNEY_PATIENT_CONTEXT_DRAWER_OPENED = "journey.patient_context.drawer_opened",
  JOURNEY_PATIENT_CONTEXT_SURVEY_CARD_OPENED = "journey.patient_context.survey_card_opened",

  // store.journeys.* — V2 practitioner-facing journey events
  STORE_JOURNEYS_VIEW_ELIGIBLE_PDP = "store.journeys.view_eligible_pdp",
  STORE_JOURNEYS_VIEW_ELIGIBLE_PLAN_REVIEW = "store.journeys.view_eligible_plan_review",
  STORE_JOURNEYS_TOGGLE = "store.journeys.toggle",
  STORE_JOURNEYS_PREVIEW_CLICK = "store.journeys.preview_click",
  STORE_JOURNEYS_NUDGE_MODAL_CLICK = "store.journeys.nudge_modal_click",
  STORE_JOURNEYS_SEND_REMINDER = "store.journeys.send_reminder",

  // store.journeys_onboarding.* — Provider profile onboarding funnel events
  STORE_JOURNEYS_ONBOARDING_CTA_CLICK = "store.journeys_onboarding.cta_click",
  STORE_JOURNEYS_ONBOARDING_STEP_2_VIEWED = "store.journeys_onboarding.step_2.viewed",
  STORE_JOURNEYS_ONBOARDING_STEP_2_DISPLAY_NAME_CHANGED = "store.journeys_onboarding.step_2.display_name_changed",
  STORE_JOURNEYS_ONBOARDING_STEP_2_THEME_CHANGED = "store.journeys_onboarding.step_2.theme_changed",
  STORE_JOURNEYS_ONBOARDING_STEP_3_VIEWED = "store.journeys_onboarding.step_3.viewed",
  STORE_JOURNEYS_ONBOARDING_SECTION_EDIT_OPENED = "store.journeys_onboarding.section_edit_opened",
  STORE_JOURNEYS_ONBOARDING_SECTION_SAVED = "store.journeys_onboarding.section_saved",
  STORE_JOURNEYS_ONBOARDING_SECTION_EDIT_CANCELED = "store.journeys_onboarding.section_edit_canceled",
  STORE_JOURNEYS_ONBOARDING_STEP_3_CONTINUE_CLICKED = "store.journeys_onboarding.step_3.continue_clicked",
}
